import request from '../utils/adminrequest'


export function login(data) {
    return request({
    url: '/login',
    method: 'post',
    data
    })
}

export function captcha() {
    return request({
    url: '/captcha',
    method: 'get',
    })
}

export function createCustomer(data) {
    return request({
    url: '/customer',
    method: 'post',
    data
    })
}

export function getCustomers(params) {
    return request({
    url: '/customer',
    method: 'get',
    params
    })
}

export function updateCustomers(id,data) {
    return request({
    url: `/customer/${id}`,
    method: 'put',
    data
    })
}

export function delCustomer(id,data) {
    return request({
    url: `/customer/${id}`,
    method: 'delete',
    data
    })
}


export function createCard( data){
    return request({
    url: '/card',
    method: 'post',
    data,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
    }) 
}

export function updateCard(id, data){
    return request({
    url: `/card/${id}`,
    method: 'put',
    data,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
    }) 
}

export function delCard(id, data){
    return request({
    url: `/card/${id}`,
    method: 'delete',
    data,
    }) 
}

export function GenQrcode(data){
    return request({
    url: '/customer/qrcode',
    method: 'post',
    data,
    }) 
}

export function getShops(params){
    return request({
    url: '/shop',
    method: 'get',
    params
    })
}


export function createShop(data){
    return request({
    url: '/shop',
    method: 'post',
    data
    })
}


export function updateShop(id, data){
    return request({
    url: `/shop/${id}`,
    method: 'put',
    data
    })
}

export function deleteShop(id, data){
    return request({
    url: `/shop/${id}`,
    method: 'delete',
    data
    })
}